import store from "@app2/store";
import {set} from "@app2/utils/helpers";

export const isSubscriptionCancelled = () => {
    const activeSubscription = store.getters['auth/GET_SUBSCRIPTION'];
    return activeSubscription?.status === 'cancelled';
};

export const handleSubscription = async (to, from, next) => {
    if ( to.name === 'RegisterForm' && to.query.checkout && to.query.step === 'payment' ) {
        next();
        return;
    }
    if ( to.name === from.name && JSON.stringify(to.params) === JSON.stringify(from.params) && JSON.stringify(to.query) === JSON.stringify(from.query) ) {
        next(false);
        return;
    }
    const activeSubscription = store.getters['auth/GET_SUBSCRIPTION'];
    const user = store.getters['auth/GET_USER'];
    if (!activeSubscription && user?.meta?.trial_hash) {
        if ( !window.Searchie?.checkout ) {
            await store.dispatch('auth/fetchPlan', user.meta?.trial_hash);
            set(window, 'Searchie.checkout', store.getters['auth/GET_PLANS'].find(plan => plan.hash === user.meta?.trial_hash));
        }
        const coupon = user.meta?.checkout_coupon;
        next({name: 'RegisterForm', query: {checkout: user.meta?.trial_hash, coupon, step: "payment"}});
        return;
    }
    if (isSubscriptionCancelled() && !to.path.includes('/settings/')) {
        next({name: 'AccountSubscription'});
    } else {
        // User is subscribed, allow navigation to the target route
        next();
    }
};

export const subscribedGuard = async (to, from, next) => {
    const user = store.getters['auth/GET_USER'];
    if (!user) {
        next({name: 'Login'});
        return;
    }
    await handleSubscription(to, from, next);
};